import { Suspense } from 'react';
import {
  Button,
  AntoreeCustomizeLoading,
  Spacer,
  Text,
  Title,
} from '@antoree/ant-ui';
import { ErrorBoundary } from 'components';
import { ToastProvider } from 'components/ToastProvider';
import AppProvider from 'AppProvider';
import AppRouter from 'AppRouter';
import { Helmet, HelmetProvider } from 'react-helmet-async';
const fallbackComponent = (
  <div className="flex flex-col items-center justify-center justify-items-center fixed top-0 left-0 h-screen w-screen">
    {/* <LoadingSpinner size="xl" />
    <Text>
      <p>Loading...</p>
    </Text> */}
    <AntoreeCustomizeLoading />
  </div>
);

export default function App() {
  return (
    <Suspense fallback={fallbackComponent}>
      <ErrorBoundary>
        <ToastProvider>
          <AppProvider>
            <AppRouter />
          </AppProvider>
        </ToastProvider>
      </ErrorBoundary>
    </Suspense>
  );
}
